import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, the } from './customStyles';

const MarketDropdown = ({ allScripts, onMarketChange, onScriptReset }) => {
    const [market, setMarket] = useState([]); 
    const [selectedMarket, setSelectedMarket] = useState(''); 

    useEffect(() => {
        const marketData = [];
        for (const category in allScripts) {
            marketData.push({ label: category, value: category });
        }
        setMarket(marketData);
    }, [allScripts]);

    const handleMarketDropdown = (selectedOption) => {
        if (selectedOption) {
            setSelectedMarket(selectedOption.value); 
            onMarketChange(selectedOption.value);
            onScriptReset();
        } else {
            setSelectedMarket(null); 
            onMarketChange(null); 
            onScriptReset(); 
        }
    };

    return (
        <Col>
            <Select
                options={market}
                value={market.find(mkt => mkt.value === selectedMarket)}
                onChange={handleMarketDropdown}
                isMulti={false}
                isClearable
                placeholder="Select"
                theme={the}
                styles={customStyles}
            />
        </Col>
    );
};

export default MarketDropdown;
